import { jsx as _jsx } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = "#loading-spinner {\n  border: 3px solid #d6d6d6;\n  border-top: 3px solid #222;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}";
  const fileName = "LoadingSpinner_LoadingSpinner_593b9c01-25db-4944-8a34-3dc3a1a9112f";
  const element = document.querySelector("style[data-sass-component='LoadingSpinner_LoadingSpinner_593b9c01-25db-4944-8a34-3dc3a1a9112f']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const LoadingSpinner = () => {
  return /*#__PURE__*/_jsx("div", {
    id: 'loading-spinner'
  });
};
export { LoadingSpinner };